<mat-radio-group aria-label="Select an option" [(ngModel)]="model" [required]="required" (change)="updateNewValue($event)">
    @for (value of values; track value) {
    <mat-radio-button [ngClass]="style" [value]="value?.value" porAddFeature [featureName]="featureName">{{ value?.text }}</mat-radio-button>
    }
</mat-radio-group>
